export const buttonBackground = '#E015A2';
export const currentScreen = window.innerWidth / 1349;
